import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import i18n from 'config/i18n';

import { ISubscriptionDetails, PLAN_TYPE, SUBSCRIPTION_STATUS } from 'models/subscriptionManagmentModel';
import { getSubscriptionDetails } from 'services/subscriptionManagement/subscriptionManagementApi';

export const fetchSubscription = createAsyncThunk('subscription/fetchSubscription', async (lang?: string) => {
  const languageCode = lang ?? i18n.language;
  return await getSubscriptionDetails(languageCode);
});

export interface SubscriptionState {
  data: ISubscriptionDetails | null;
  isExpiredTrial: boolean | null;
  loading: boolean;
  error: string | null;
}

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    data: null,
    isExpiredTrial: null,
    loading: false,
    error: null,
  } as SubscriptionState,
  reducers: {
    updateSubscriptionData(state, action: PayloadAction<ISubscriptionDetails>) {
      if (state.data) {
        state.data = action.payload;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.isExpiredTrial = action.payload.planTypeId === PLAN_TYPE.TRIAL && action.payload.statusId === SUBSCRIPTION_STATUS.EXPIRED;
      })
      .addCase(fetchSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'An error occurred.';
      });
  },
});

export const { updateSubscriptionData, setLoading } = subscriptionSlice.actions;

export default subscriptionSlice;
